import isoCountries from 'i18n-iso-countries'

isoCountries.registerLocale(require('i18n-iso-countries/langs/de.json'))
const countryItems = isoCountries.getNames('de')

export function countries() {
  return countryItems
}
